import React, { Component } from "react";
import _ from 'lodash';
import '../assets/styles/NewClinic.scss';
import { clinicService } from '../services/clinic';
import { doctorService } from '../services/doctor';
import { userService } from '../services/user';
import { insuranceService } from '../services/insurance';
import default_clinic_img from '../assets/images/clinic_default.png';
import ClinicMap from "./ClinicMap";
import whatsapp_icon from '../assets/images/whatsapp_icon.png';
import phone_icon from '../assets/images/phone_icon_2.png';
import pin_icon from '../assets/images/location-pin-icon-2.png';
import {Tabs, Tab} from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';
import FsLightbox from "fslightbox-react";

import ProfessionalCard from "./ProfessionalCard";
import OperationHour from "./OperationHour";
import Pagination from '@material-ui/lab/Pagination';
import { CustomMessageDialog } from "./CustomMessageDialog";
import SEO from './SEO';

class NewClinic extends Component {

    constructor(props){
        super(props);

        this.state = {
            clinic: {},
            doctors: [],
            key: 'profile',
            result_pageindex: 1,
            meta: {},
            showCustomMessageDialog: false,
            metadata: {
                title: 'Search & Book - BookDoc',
                description: 'Book appointments via BookDoc now!',
                type: 'website'
            },
            lightbox: {
                toggle: false,
                slide: 2
            },
            insurances: []
        }

        this.handleOnFav = this.handleOnFav.bind(this);
        this.handleCustomMessageDialog = this.handleCustomMessageDialog.bind(this);
    }
    handleCustomMessageDialog = (isOpen) => this.setState({ showCustomMessageDialog: isOpen });

    componentDidMount(){
        this.getClinic(this.props.match.params.location_friendly_id);
        this.getInsurances();
    }

    openlightbox(slideNumber){
        this.setState({
            lightbox: {
                toggle: !this.state.lightbox.toggle,
                slide: slideNumber
            }
        })
    }

    getInsurances(){
        insuranceService.get()
        .then(
            data => {
              if(data){
                this.setState({
                  insurances: data
                });
              }
            },
            error => {
                console.log(error)
            }
        );
    }

    getClinic(location_friendly_id){
        clinicService.get(location_friendly_id)
        .then(
            data => {
                if(!_.has(data, 'errors')){
                    if (data.alert_popup_message != null && data.alert_popup_message !== ""){
                        this.handleCustomMessageDialog(true)
                    }
                    this.getDoctors(this.state.result_pageindex);
                    let clinic_name = data.name;
                    this.setState(prevState => ({
                        clinic: data,
                        metadata: {
                            ...prevState.metadata,
                            title: `Search & Book - ${clinic_name}`,
                            description: `Book a doctor/dentist in ${clinic_name} via BookDoc!`
                        }
                    }))
                }
            },
            error => {
                console.log(error)
                this.setState({ error, loading: false })
            }
        );
    }

    getDoctors(pageindex){
        let params = {
            location_id: this.props.match.params.location_friendly_id,
            perpage: 10,
            pageindex: pageindex
        }
        doctorService.searchDoctors(params)
        .then(
            data => {
                this.setState({
                    doctors: data.doctors,
                    meta: data.meta
                })
            },
            error => {
                console.log(error)
                this.setState({ error, loading: false })
            }
        );
    }

    openGoogleMapDirection(){
        let url = `https://www.google.com/maps/dir//${this.state.clinic.latitude},${this.state.clinic.longitude}`
        const newTab = window.open(url, '_blank')
        if (newTab) newTab.opener = null
    }

    setTabKey(key){
        this.setState({ key: key})
    }

    handleOnFav(doctor_id, isFav, location_id = null){
        this.setState({
            doctors: this.state.doctors.map(el => (el.id === doctor_id ? Object.assign({}, el, { favorited: !isFav }) : el))
        });
    }

    handlePageChange = (event, value) => {
        this.setState({result_pageindex: value});
        this.getDoctors(value);
     };

    getWhatsappLink(whatsapp_number){
        return <a href={`https://wa.me/${whatsapp_number}?text=Hi%2C%20I%20have%20been%20referred%20by%20BookDoc%20and%20would%20like%20to%20make%20an%20enquiry.`} target="_blank" rel="noopener noreferrer"><img className="contact-icon whatsapp-phone" src={whatsapp_icon} alt='contact-whatsapp' /></a>
    }

    photoGallery = (photos) => {
        return (
            <>
                {
                    photos.map((item, index) => (
                        <button onClick={() => this.openlightbox(index+1)} className="btn btn-link sub-photo" key={`photo-${index}`}>
                            <img className="d-block h-100 m-auto w-100" src={item.url.origin.url} alt='clinic-location' onError={(e) => { e.target.src = default_clinic_img }}/>
                        </button>
                    ))
                }
                <FsLightbox
                    toggler={this.state.lightbox.toggle}
                    sources={photos.map((x,i) => ( x.url.origin.url ))}
                    type="image"
                    slide={this.state.lightbox.slide}
                />
            </>
        )
    }

    render() {
        if (_.isEmpty(this.state.clinic)){
            return (
                <div className="loader"><Spinner animation="border" /></div>
            )
        }else{
            return (
                <>
                <SEO 
                title={this.state.metadata.title} 
                description={this.state.metadata.description}
                type={this.state.metadata.type} />
                <div className="new-clinic-page container">
                    <div className="header">
                        <h1 className="title">Online Appointment</h1>
                        <div className="bread-crumb">Home / Search & Book / Clinic</div>
                    </div>
                    <hr className="header-line"/>
                    <div className="body">
                        <div className="clinic-sub-details">
                            <div className="details-container">
                                <div className="address-col">
                                  {this.state.clinic.clinic_main_photo_location &&
                                    <div className="img-slider">
                                        <img className="d-block h-100 m-auto w-100" src={this.state.clinic.clinic_main_photo_location.url.origin.url} alt='clinic-location' onError={(e) => { e.target.src = default_clinic_img }}/>
                                    </div>
                                  }
                                  <h2 className="address-name">{this.state.clinic.name}</h2>
                                </div>
                            </div>
                            <div className="clinic-details mobile-v">

                            <div className="location-container d-flex">
                                <h3 className="address">{this.state.clinic.address}, {[this.state.clinic.zipcode, this.state.clinic.state].filter(Boolean).join(" ")}</h3>
                            </div>
                            <div className="map-container">
                                <ClinicMap clinic={this.state.clinic}/>
                            </div>
                            <div className="contact-info-container">
                                <button className="btn btn-link direction-tag" onClick={() => this.openGoogleMapDirection()}>Get Direction</button>
                                {userService.getUser() &&
                                    <div className="phone-email-container">
                                        {this.state.clinic.whatsapp_number && this.getWhatsappLink(this.state.clinic.whatsapp_number)}
                                        <a href={`tel:${this.state.clinic.phone}`}><img className="contact-icon phone" src={phone_icon} alt='contact-phone' /></a>
                                    </div> 
                                }
                            </div>
                                
                              <div className="operation-hours-container">
                                <div className="title">Operation Hours</div>
                                <div className="operation-hours">
                                  <OperationHour operatingHours={this.state.clinic.operating_hours} />
                                </div>
                              </div>
                            </div>
                            <hr className="details-line"/>
                            <Tabs id="tabs-container" className="tabs-container" activeKey={this.state.key} onSelect={(k) => this.setTabKey(k)}>
                                <Tab eventKey="profile" title="Profile">
                                    {this.state.clinic.description &&
                                        <div className="tab-detail-container">
                                            <h3 className="tab-title">Summary</h3>
                                            <h4 className="tab-content">{this.state.clinic.description}</h4>
                                        </div>
                                    }
                                </Tab>
                                <Tab eventKey="professional" title="Professional">
                                    <div className="tab-detail-container prof">
                                    {
                                        this.state.doctors.map((doctor, index) => (
                                            <ProfessionalCard key={`doc-card-${index}`} doctor={doctor} onFav={this.handleOnFav} insurances={this.state.insurances}/>
                                        ))
                                    }
                                    </div>
                                    {this.state.meta.total_pages > 1 &&
                                        <Pagination className="container" count={this.state.meta.total_pages} page={this.state.page_no} onChange={this.handlePageChange}/>
                                    }
                                </Tab>
                                <Tab eventKey="services" title="Services">
                                    <div className="tab-detail-container">
                                        <h3 className="tab-title">Services/Procedures</h3>
                                        <ul className="tab-content list">
                                            {
                                                this.state.clinic.services.map((service, index) => (
                                                    <li key={`service-${index}`}><h4 className="service-item">{service.name}</h4></li>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                </Tab>
                                <Tab eventKey="photos" title="Photos">
                                    <div className="tab-detail-container">
                                        <div className="tab-content row">
                                        {this.state.clinic.clinic_photo_locations.length > 0 ? 
                                            <>{this.photoGallery(this.state.clinic.clinic_photo_locations)}</>
                                        : <div className="tab-title m-auto">No Photo</div>
                                        }
                                        </div>
                                    </div>
                                </Tab>
                            </Tabs>
                        </div>
                        <div className="clinic-details desktop-v">
                          <div className="map-container">
                            <ClinicMap clinic={this.state.clinic}/>
                          </div>
                          <div className="contact-details-container">
                            <div className="location-container d-flex">
                              <div><img className="location-pin-icon" src={pin_icon} alt='location-pin'/></div>
                              <div>
                                <h2 className="address-name">{this.state.clinic.name}</h2>
                                <h3 className="address">{this.state.clinic.address}, {[this.state.clinic.zipcode, this.state.clinic.state].filter(Boolean).join(" ")}</h3>
                              </div>
                            </div>
                            <div className="contact-info-container">
                              <button className="btn btn-link direction-tag" onClick={() => this.openGoogleMapDirection()}>Get Direction</button>
                              {userService.getUser() &&
                                <div className="phone-email-container">
                                    {this.state.clinic.whatsapp_number && this.getWhatsappLink(this.state.clinic.whatsapp_number)}
                                    <a href={`tel:${this.state.clinic.phone}`}><img className="contact-icon phone" src={phone_icon} alt='contact-phone' /></a>
                                </div> 
                              }
                            </div>
                          </div>
                          <div className="operation-hours-container">
                            <div className="title">Operation Hours</div>
                            <div className="operation-hours">
                              <OperationHour operatingHours={this.state.clinic.operating_hours} />
                            </div>
                          </div>
                        </div>
                    </div>

                    <React.Fragment>
                        <CustomMessageDialog showCustomMessageDialog={this.state.showCustomMessageDialog} customMessage={this.state.clinic.alert_popup_message} handleCustomMessageDialog={this.handleCustomMessageDialog} />
                    </React.Fragment>
                </div>
                
                </>

            )
        }

    };
}

export { NewClinic };
